// extracted by mini-css-extract-plugin
export default {"wrapperMob":"TradeViewChartButton_wrapperMob__wQugV","wrapper":"TradeViewChartButton_wrapper__GQXP0"};